<template>
  <div>
    <img
      :class="leiding.id % 2 == 1 ? 'left' : 'right'"
      class="position-absolute img-fluid d-block normaal"
      :src="'/images/leiding/' + leiding.naam + '.jpg'"
      alt="foto leiding"
    />
    <img
      :class="leiding.id % 2 == 1 ? 'left' : 'right'"
      class="position-absolute img-fluid d-block zot"
      :src="'/images/leiding/zot/' + leiding.naam + '.jpg'"
      alt="foto leiding"
    />
  </div>
</template>
<script>
export default {
  name: 'leiding-image',
  props: ['leiding'],
};
</script>
